import breakpoints from '../../../theme/breakpoints'
import theme from '../../../theme/news12'
import redesignedTheme from '../../../theme/news12-redesign'

import css from 'styled-jsx/css'

export default css`
  .main-layout-container {
    width: fit-content;
    margin: 0 auto;
    padding-top: 24px; 
  }

  .main-layout-sidebar {
    display: inline-block;
    vertical-align: top;
    margin-left: 14px;
    top: 120px;
  }

  .main-layout {
    display: inline-block;
    width: 728px;
    background-color: ${theme.colors.white};
  }

  .byline {
    font-weight: 600;
    font-size: 24px;    
    margin-bottom: 0px;
  }

  .position {
    margin-top: 2px;
    font-weight: 400;
    font-size: 16px;
  }

  .new12-logo {
    height: 151px;
    width: 227px;
    margin: 14px 21px 0 0;
    object-fit: contain;
    font-size: 24px;    
    margin-bottom: 0px;
  }

  .position {
    margin-top: 2px;
    font-weight: 400;
    font-size: 16px;
  }

  .new12-logo {
    height: 151px;
    width: 227px;
    margin: 14px 21px 0 0;
    object-fit: contain;
  }
  
  .author-info {
    display: flex;
    align-items: flex-start;
    font-weight: 400;
    font-size: 14px;
    line-height: 22px;
    margin-bottom: 30px;
  }

  .divider {
    height: 1px;
    width: 100%;
    border-top: 1px solid ${redesignedTheme.colors.mist};
    margin: 15px 0;
  }

  .image-hd {
    width: 227px;
    margin: 14px 21px 0 0;
  }

  .responsive {
    box-sizing: 'border-box';
    width: 100%;
  }

  .cards-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 40px 19px;
    margin-bottom: 68px;
    margin-top: 30px;
  }

@media only screen and (min-width: ${breakpoints.sm}px) {
  .responsive {
    width: 50%;
  }
}

@media only screen and (min-width: ${breakpoints.md}px) {
  .responsive {
    width: 33%;
  }
}

@media only screen and (max-width: 1280px) {
  .main-layout-sidebar {
    display: none;
  }
}

@media only screen and (max-width: ${breakpoints.md}px) {
  .main-layout-container {
    width: 100%;
    background-color: ${theme.colors.drWhite};
    padding-top: 20px;
  }

  .main-layout {
    display: block;
    background-color: ${theme.colors.drWhite};
    width: 85%;
    margin: 0 auto;
  }

  .author-info {
    flex-direction: column;
  }

  .author-info img {
    width: 100%;
  }

  .cards-grid { 
    grid-template-columns: 1fr;
  }
}
`
